import { inject as o } from "vue";
const u = Symbol("@css-render/vue3-ssr");
function c(n, e) {
  return `<style cssr-id="${n}">
${e}
</style>`;
}
function l(n, e) {
  const r = o(u, null);
  if (r === null) {
    console.error("[css-render/vue3-ssr]: no ssr context found.");
    return;
  }
  const { styles: t, ids: s } = r;
  s.has(n) || t !== null && (s.add(n), t.push(c(n, e)));
}
const d = typeof document < "u";
function f() {
  if (d)
    return;
  const n = o(u, null);
  if (n !== null)
    return {
      adapter: l,
      context: n
    };
}
export {
  f as useSsrAdapter
};
